(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HtmlElement } from "../base";
var Div = styled(HtmlElement).withConfig({
  displayName: "Div",
  componentId: "sc-17442o6-0"
})(["", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return typeof props.margin === 'undefined' ? '' : "margin: ".concat(props.margin, ";");
}, function (props) {
  return typeof props.padding === 'undefined' ? '' : props.padding && "padding: ".concat(props.padding, ";");
}, function (props) {
  return typeof props.flex === 'undefined' ? '' : "flex: ".concat(props.flex, ";");
}, function (props) {
  return typeof props.flexGrow === 'undefined' ? '' : "flex-grow: ".concat(props.flexGrow, ";");
}, function (props) {
  return typeof props.flexShrink === 'undefined' ? '' : "flex-shrink: ".concat(props.flexShrink, ";");
}, function (props) {
  return typeof props.textAlign === 'undefined' ? '' : "text-align: ".concat(props.textAlign, ";");
}, function (props) {
  return typeof props.width === 'undefined' ? '' : "width: ".concat(props.width, ";");
}, function (props) {
  return typeof props.maxWidth === 'undefined' ? '' : "max-width: ".concat(props.maxWidth, ";");
});
Div.propTypes = {
  margin: PropTypes.string,
  padding: PropTypes.string,
  flex: PropTypes.string,
  flexGrow: PropTypes.string,
  flexShrink: PropTypes.string,
  textAlign: PropTypes.string,
  width: PropTypes.string,
  maxWidth: PropTypes.string
};
var _default = Div;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Div, "Div", "/home/vsts/work/1/s/src/components/layout/Div.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/layout/Div.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();